import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetData_importTemplates = z.any()
export type TagsGetData_importTemplates = z.infer<typeof tagsGetData_importTemplates>

export const responseGetData_importTemplates = z.object({ "payload": z.object({ "templates": z.array(z.object({ "kind": z.union([z.literal("readings"), z.literal("invoices")]), "filename": z.string(), "csv": z.string(), "variant": z.union([z.literal("existing"), z.literal("new")]).optional(), "xlsx": z.string().optional(), "columns": z.array(z.object({ "header": z.string(), "description": z.string() })) })) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetData_importTemplates = z.infer<typeof responseGetData_importTemplates>

interface IGetData_importTemplates extends BaseMethodType {
  tags: TagsGetData_importTemplates,
  response: ResponseGetData_importTemplates
}
export const URL = '/data-import/templates'
export const validation = {
  get: {
    tags: tagsGetData_importTemplates,
    response: responseGetData_importTemplates
  }
}
export interface Data_importTemplates extends BaseRouteType {
  get: IGetData_importTemplates
}